// Opt-in gtag adapter. The form module emits CustomEvents; this listens.
// Swapping analytics tools means replacing this file — the form never changes.

export function initAnalyticsGtag() {
	document.addEventListener('form:success', (e) => {
		if (typeof window.gtag !== 'function') return;

		window.gtag('event', 'generate_lead', {
			form_name: e.target?.dataset?.formName || 'form',
			page_location: window.location.href,
		});
	});
}
